// extracted by mini-css-extract-plugin
export default {"welcome":"welcome_welcome__roDe3","host":"welcome_host__JtpQb"};